//大小寫需一致
const en = {
  // 'app.learn': 'Learn {name}'
  // , "app.Salmon": "{name} Salmon"
  // , "app.loginMessage": "Please enter your account and password..."
  // //userinfo
  // , "app.screenLockMessage": "Please enter your password..."
  // , "app.screenLock": "Screen Lock"
  // , "app.loginMessage_Error": "Account or Password Error"
  // , "app.PasswordNotMatch": "New Password Not Match"
  // , "passwordOld": "Old Password"
  // , "passwordNew": "New Password"
  // , "passwordConfirm": "Confirm Password"
  // , "app.changePw": "Change Your Password"
  "app.LoginButton": "Login"
  , "UserName": "Name"
  , "birthDate": "Birthday"
  , "personalId": "ID number"
  , "app.Clear": "Clear"
  , "請填寫這個欄位。": "Please fill in."
  , "請符合要求的格式。": "Please fill with correct format."
  , "app.LoginCantFound": "Sorry, Could not find your reservation.\r\nPlease contact 04-2255-2555 #168"
  , "app.AllQuestsDone": "All questionaires have done, Many thanks"
  , "app.FillNextTime": "Logout"
  , "app.Logout": "Logout"
  , "app.Next": "Next"
  , "app.Back": "Back"
  , "app.Done": "Done"
  , "app.QuestsNotYet": "This questionaire is not finish.Please submit this questionaire."
  , "app.ThankWords": "Thanks for patience"
  , "app.ThankDone": "All is done"

  , "app.Submit": "Submit"
  , "app.Cancel": "X"
  , "尚有問題未完成": "Some question not be completed"
  , "填寫此欄位": "Please fill in."
  , "選擇其中一個選項": "Please select one of them"
  , "勾選此註記框": "Please tick one of them"
  , "輸入數字": "Number only"
  , "app.pleaseSelect": "Please choose one"
  //問卷所寫
  , "心血管": "Angiocarpy"
  , "肌肉骨骼": "Musculoskeletal"
  , "心情量表": "Mental Scale"
  , "過勞評估": "Fatigue"
  , "勞檢問卷": "Labor"
  , "無紙化": "Email"
  //70
  , "十年心血管風險評估": "10 years Angiocarpy Risk Evaluation"
  , "填寫前說明": "Instructions"
  , "基本資料": "Basic Information"
  , "體檢後": "After the examination"
  , "你有沒有吸煙：": "Do you have smoking"
  , "你有沒有服用高血壓藥物：": "Do you take any Antihypertensive drug"
  , "你有沒有糖尿病史：": "Do you have diabetes"
  , "沒有": "No"
  , "有吸煙": "have smoked"
  , "有服用高血壓藥物": "Take Antihypertensive drug"
  , "有糖尿病史": "have diabetes"
  , "說明：本測驗不適用於已被診斷出心血管疾病者或有接受治療者。": "This Test is not appropriate for person who diagnosed angiocardiopathy"
  , "取得檢測數字[總膽固醇]-[高密度脂蛋白膽固醇]-[收縮壓]，進行風險評估試算，產生[未來10年心血管疾病風險評估表]": "Obtain test numbers [total cholesterol]-[high-density lipoprotein cholesterol]-[systolic blood pressure], perform a risk assessment trial calculation, and produce a [10-year cardiovascular disease risk assessment table]"
  //無紙化
  , "app.NopaperComfirm": "之前已確認使用無紙化服務，感謝與您一同保護地球！"
  , "app.NopaperNoexit": "There is no customer data, please mind"
  , "健檢報告無紙化服務同意書": "Examination Report Email informed consent"
  , "本人": "My name is "
  , "支持 ": "support to "
  , "晨悅診所響應環保、節能愛地球": "the Mornjoy clinic committed to environmental protection"
  , "之活動，": ","
  , "同意": " agree"
  , " 晨悅診所將本人健康檢查報告，": " the Mornjoy clinic send my Examination Report "
  , "完成後以email方式通知至本人指定之電子信箱": "by email which I assign hereby "
  , "，資料如下": "as following "
  , "立書同意人：": "Consenter："
  , "身分證字號：": "ID number："
  , "E-mail:   (用於通知報告完成，請您確認正確)": "E-mail:   (In order to inform you after the Report is done, please review email)"
  , "簽名時間：": "Time："
  , "Email確認正確": "Email Correct"
  , "點擊按鈕才算完成": "Finish when click above button"
  , "謝謝": "Many thanks! Please click Next in the top right corner to continue"


  //sign
  , "簽名": "Sign in"
  , "重新簽名": "Re-sign"
  , "確認": "comfirm"
  , "請簽名(行動裝置請旋轉螢幕為水平橫向)...": "Please Sign in(Rotate your cellphone horizontally)..."

  //肌肉骨骼
  , "肌肉骨骼症狀調查表": "Investigation of Musculoskeletal Symptom"
  , "痠痛症狀調查": "Investigation of Ache"
  , "其他症狀、病史說明": "Others Symptom and Medical History"
  , "右腳踝/右腳": "Right ankle/foot"
  , "左腳踝/左腳": "Left ankle/foot"
  , "右膝": "Right knee"
  , "左膝": "Left knee"
  , "右臀/右大腿": "R-Buttock/Thigh"
  , "左臀/左大腿": "L-Buttock/Thigh"
  , "右手/右手腕": "R-hand/wrist"
  , "左手/左手腕": "L-hand/wrist"
  , "右手肘/右前臂": "R-elbow/forearm"
  , "左手肘/左前臂": "L-elbow/forearm"
  , "右肩部": "Right Shoulder"
  , "左肩部": "Left Shoulder"
  , "下背部": "Lower-Back"
  , "上背部": "Upper-Back"
  , "頸部": "Neck"
  , "痠痛症狀調查(請對應位置，在量化後的分數欄位中點選)：": "Investigation of Ache(According the body position, Please choose one of them)："
  , "0表示『不痛』;1表示『痛可忽略』;2表示『可能影響工作』;3表示『影響工作』;4表示『影響自主活動功能』;5表示『完全無法自主活動』": "0 means『Fine』;1 means『Mild pain』;2 means『Might Affect Jobs』;3 means『Affect Jobs』;4 means『Affect  Self-activity』;5 means『Completely Affect  Self-activity』"
  , "下表的身體部位酸痛、不適或影響關節活動之情形持續多久時間？": "How long is your ache?"
  , "您平常使用電腦、滑鼠慣用手為？": "According to your mouse habbit for using computer?"
  , " 左手": "Left hand"
  , " 右手": "Right hand"
  , "是（若是，請繼續填寫下列表格。）": "Yes（if so, Please continuous.）"
  , "否（若否，結束此調查表）": "No（if so, it's done）"
  , "1個月": "1 month"
  , "3個月": "3 months"
  , "6個月": "6 months"
  , "1年": "1 Year"
  , "3年": "3 Years"
  , "3年以上": ">= 3 Years"
  , "下列任何部位請以酸痛不適與影響關節活動評斷。任選分數高者。": "Please see the photo below, according to self-activities of your body "
  , "酸痛不適程度與關節活動能力：（以肩關節為例） 請在第二部分作答": "capacity of activity in your Shoulder joint. Is there any Ache?(Form left to right, means more ache). Please answer in part II"
  , "不痛": "Fine"
  , "痛可忽略": "Mild pain"
  , "可能影響工作": "Might Affect Jobs"
  , "影響工作": "Affect Jobs"
  , "影響自主活動功能": "Affect Self-activity"
  , "完全無法自主活動": "Completely Affect  Self-activity"
  , "您在過去的1年內，身體是否有長達2星期以上的疲勞、酸痛、發麻、刺痛等不舒服，或關節活動受到限制？": "Until recently one year, do your body have any fatigue, ache, pins/needles, pricking, limited action in joint for more than 2 weeks?"

  , "晨悅預防醫學": "MornJoy Preventive Healthcare"
  , "健康人生，攜手晨悅": "Health Life, MornJoy Together"
  , "請選取其中一個選項。": "Please select one at lease"

  //心情量表
  , "計分方式": "Scoring Formula"
  , "沒有或極少": "None or few"
  , "有時候": "Sometimes"
  , "時常": "Often"
  , "常常或總是": "Often or always"
  , "我常常覺得想哭": "I wanna cry oftenly"
  , "我覺得心情不好": "I'm feeling rather blue"
  , "我覺得比以前容易發脾氣": "I feel more irritability"
  , "我睡不好": "I could not sleep well"
  , "我覺得不想吃東西": "I don't wanna eat"
  , "我覺得胸口悶悶的": "I have a feeling of tightness in my chest"
  , "我覺得不輕鬆、不舒服": "I feel strange"
  , "我覺得身體疲勞虛弱無力": "I feel tired and weak"
  , "我覺得很煩": "I feel annoyed"
  , "我覺得記憶力不好": "I can't remember well"
  , "我覺得做事時無法專心": "I can't concentrate on something"
  , "我覺得想事情或做事時比平常要緩慢": "I feel I'm doing things more slowly than usual"
  , "我覺得比以前沒信心": "I feel no cofidence"
  , "我覺得比較會往壞處想": "I think it's often getting worst"
  , "我覺得想不開，甚至想死": "I feel gloomy, even want to die"
  , "我覺得對什麼事都失去興趣": "I am not interesting in everything"
  , "我覺得身體不舒服": "I don't feel well in body"
  , "我覺得自己很沒用": "I feel useless"
  , "『沒有或極少』0分；『有時候』1分；『時常』2分；『常常或總是』3分": "『None or few』:0；『Sometimes』:1；『Often』:2；『Often or always』:3"
  , "8 分以下---情緒穩定": "Below 8 point---Emotionally stable"
  , "9~14分---情緒較不穩定、多注意情緒變化，多給自己關心": "9~14 point---Emotional instability. Need takig attention to emotional changes and care for yourself"
  , "15~18分---壓力負荷已到極點，需要找朋友交談、舒緩情緒": "15~18 point---You need to talk to friends to relieve your stress load"
  , "19分以上---必須找專業醫療單位協助": "Above 19 point---Professional medical assistance must be sought"
  , "說明：本量表所列舉的問題是為協助您瞭解您的心情狀況，請您仔細回想在一星期中，這些問題發生幾天，然後圈選一個您認為最能代表您感覺的答案。『沒有或極少』1天以下/週，『有時候』1~2天/週，『時常』3~4天/週，『常常或總是』5~7天/週":
    "Instruction：The questions listed in this scale are designed to help you understand your mood, Please recall carefully for the period of one week. These questions occur how many days, then tick the answer that you think best represents your feelings。『None or few』:less than one day，『Sometimes』1~2 days，『Often』3~4 days，『Often or always』5~7 days"

  //過勞評估量表
  , "過勞評估量表": "Fatigue and Overwork Evaluation"
  , "個人疲勞": "Fatigue"
  , "工作疲勞": "Overwork"
  , "分數解釋": "Explain"
  , "個人相關過勞": "Personal Fatigue"
  , "50 分以下": "<= 50 points"
  , "輕微": "Mild"
  , "您的過負荷程度輕微，您並不常感到疲勞、體力透支、精疲力竭、或者虛弱好像快生病的樣子。":
    "Your degree of overloading is mild, and you do not often feel tired physically exhausted or weak as if you are about to get sick."
  , "50－70 分": "50－70 points"
  , "中度": "Moderate"
  , "你的個人過負荷程度中等。您有時候感到疲勞、體力透支、精疲力竭、或者虛弱好像快生病的樣子。建議您找出生活的壓力源，進一步的調適自己，增加放鬆與休息的時間。":
    "Your personal overload degree is medium. Sometimes you feel tired, physically overdrawn, exhausted or weak as if you are about to fall ill. It is recommended that you find out the source of pressure in your life, further adjust yourself, and increase the time for relaxation and rest"
  , "70 分以上": ">70 points"
  , "嚴重": "Severe"
  , "您的個人過負荷程度嚴重。您時常感到疲勞、體力透支、精疲力竭、或者虛弱好像快生病的樣子。建議您適度的改變生活方式，增加運動與休閒時間之外，您還需要進一步尋找專業人員諮詢。":
    "Your personal overload degree is serious you often feel tired physically overdrawn exhausted or weak as if you are going to get sick. It is recommended that you moderately change your lifestyle and increase your sports and leisure time. Besides, you need to seek further professional advice"
  , "工作相關過勞": "Working Fatigue"
  , "45 分以下": "< 45 points"
  , "您的工作相關過負荷程度輕微，您的工作並不會讓您感覺很沒力、心力交瘁、很挫折。": "Your work-related overload is mild, and your job doesn't make you feel drained or frustrated."
  , "45－60 分": "45－60 points"
  , "您的工作相關過負荷程度中等，您有時對工作感覺沒力，沒有興趣，有點挫折。": "Your work-related overload is moderate, and you sometimes feel tired, uninterested, and frustrated at work."
  , "60 分以上": "> 60 points"
  , "您的工作相關過負荷程度嚴重，您已經快被工作累垮了，您感覺心力交瘁，感覺挫折，而且上班時都很難熬，此外您可能缺少休閒時間，沒有時間陪伴家人朋友。建議您適度的改變生活方式，增加運動與休閒時間之外，您還需要進一步尋找專業人員諮詢。":
    "Your work related to degree of overload is serious, you have been working fast burned out, and you feel stressed, feel setback, and are hard at work, in addition you may lack of leisure time, no time with family and friends you are advised to moderate lifestyle changes, increase the sports and leisure time, you also need to look for professional consulting further."
  , "你常覺得疲勞嗎?": "Do you often feel tired?"
  , "你常覺得身體上體力透支嗎?": "Do you often feel physically exhausted?"
  , "你常覺得情緒上心力交瘁嗎?": "Do you often feel emotionally drained?"
  , "你常會覺得，「我快要撐不下去了」嗎?": "Do you often think I'm about to break down and cry?"
  , "你常覺得精疲力竭嗎?": "Do you often feel exhausted?"
  , "你常常覺得虛弱，好像快要生病了嗎?": "Do you often feel weak as if you were going to be ill?"
  , "你的工作會令人情緒上心力交瘁嗎？": "Is your job emotionally draining？"
  , "你的工作會讓你覺得快要累垮了嗎?": "Are you feeling burned out at your job?"
  , "你的工作會讓你覺得挫折嗎?": "Is your job frustrating?"
  , "工作一整天之後，你覺得精疲力竭嗎?": "Do you feel exhausted after a long day's work?"
  , "上班之前只要想到又要工作一整天，你就覺得沒力嗎?": "Do you feel drained when thinking about full day work before you go to work?"
  , "上班時你會覺得每一刻都很難熬嗎?": "Do you feel every moment tough at work?"
  , "不工作的時候，你有足夠的精力陪朋友或家人嗎?": "Do you have enough energy to spend time with friends or family when you're not working?"
  , "總是": "Always"
  , "常常": "Often"
  , "不常": "Seldom"
  , "從未或幾乎從未": "Never or few"
  , "說明：本量表所列舉的問題是為協助您瞭解您的身心適應狀況，請您仔細回想在最近一星期中(包括今天)，這些問題使您感到困擾或苦惱的程度，然後圈選一個您認為最能代表您感覺的答案。":
    "Note: The questions listed in this scale are to help you understand your physical and mental adaptation. Please carefully recall how much you have been troubled or distressed by these questions in the last week (including today), and then tick the answer that best represents your feelings"
  , "有一些": "Moderate"
  , "很嚴重": "Seriously"
  , "非常輕微": "Slightly"
  //勞工體(健)檢問卷
  , "勞工體(健)檢問卷": "Labor Health Examination"
  , "一、作業經歷：": "A. Work Experience:"
  , "1.曾經從事": "1.Previously job"
  , "起始日期:": "From"
  , "截止日期:": "To"
  , "2.目前從事": "2.Current job"
  , "3.過去 1 個月，平均每週工時為：": "3.How many weekly hours do you work in past month："
  , "小時": "hr"
  , "；過去 6 個月，平均每週工時為：": "; How many weekly hours do you work in past 6 months："
  , "新進員工": "New employees"
  , "定期檢查": "Regular Examination"
  , "二、檢查時期（原因）：": "B. Inspection Reason:"
  , "四、既往病史：": "D. Past Medical History:"
  , "您是否曾患有下列慢性疾病：（請在適當項目前打勾）": "Have you ever suffered from any of the following chronic diseases :(please tick the appropriate item)"
  , "以上皆無": "None of above"
  , "骨折": "fracture"
  , "其他慢性病": "Other chronic diseases"
  , "手術開刀": "Surgical operation"
  , "癌症": "cancer"
  , "逆流性食道炎": "Gastroesophageal reflux"
  , "消化性潰瘍、胃炎": "Gastritis "
  , "甲狀腺疾病": "thyroid disease"
  , "聽力障礙": "hearing disorder"
  , "中耳炎": "tympanitis"
  , "貧血": "anemia"
  , "肝病": "hepatopathy"
  , "腎臟病": "kidney disease"
  , "肺結核": "tuberculosis"
  , "慢性氣管炎、肺氣腫": "Chronic bronchitis and emphysema"
  , "氣喘": "asthma"
  , "癲癇": "epilepsy"
  , "中風": "stroke"
  , "白內障": "cataract"
  , "心臟病": "cardiopathy"
  , "糖尿病": "diabetes"
  , "高血壓": "hypertension"
  , "五、生活習慣：": "E. Living Habits:"
  , "1.請問您過去一個月內是否有吸菸？": "1.Have you smoke in the last one month?"
  , "從未吸菸": "Never"
  , "偶爾吸(不是天天)": "Sometimes"
  , "(幾乎)每天吸": "Everyday had"
  , "已經戒菸，戒了": "Quitted for"
  , "平均每天吸": "avg."
  , "支": "pcs"
  , "已吸菸": "for"
  , "2.請問您最近六個月內是否有嚼食檳榔？": "2.Have you chew betel in the last six months?"
  , "從未嚼食檳榔": "Never"
  , "偶爾嚼(不是天天)": "Sometimes"
  , "(幾乎)每天嚼": "Everyday had"
  , "已經戒食，戒了": "Quitted for"
  , "平均每天嚼": "avg."
  , "已嚼 ": "for"
  , "3.請問您過去一個月內是否有喝酒？": "3.Have you had any alcohol in the past month?"
  , "從未喝酒": "Never"
  , "偶爾喝(不是天天)": "Sometimes"
  , "（幾乎）每天喝": "Everyday had"
  , "已經戒酒，戒了": "Quitted for"
  , "平均每週喝": "avg."
  , "最常喝 ": "favor"
  , "酒": "liquor"
  , "每次 ": "Each"
  , "瓶": "bottle(s)"
  , "4.請問您於工作日期間，平均每天睡眠時間為：": "4.How many hours do your average daily sleep time during working days?"
  , "六、自覺症狀：": "F. Subjective Symptom："
  , "三、關係人：": "C. Relevant Person："
  , "您最近三個月是否常有下列症狀：（請在適當項目前打勾）": "Have you had the following symptoms in the last 3 months :(please check the appropriate item)"
  , "咳嗽": "cough"
  , "咳痰": "expectoration"
  , "呼吸困難": "breathing difficulties"
  , "胸痛": "chest pain"
  , "心悸": "palpitation"
  , "頭暈": "swirl"
  , "頭痛": "headache"
  , "耳鳴": "tinnitus"
  , "倦怠": "Tireness"
  , "噁心": "nausea"
  , "腹痛": "stomachache"
  , "便秘": "constipation"
  , "腹瀉": "diarrhea"
  , "血便": "bloody stools"
  , "上背痛": "Upper-Back pain"
  , "下背痛": "Lower-Back pain"
  , "手腳麻痛": "arms and legs numbness"
  , "關節疼痛": "joint pain"
  , "排尿不適": "urination difficulties"
  , "多尿、頻尿": "diuresis"
  , "手腳肌肉無力": "myasthenia"
  , "體重減輕 3公斤以上": "Weight Loss > 3kg"
  , "其他症狀": "other symptoms"
  , "年": "y"
  , "個月": "m"
  , "次": "times"
  , "顆": "pcs"
  , "共": "for"
  , "忘記日期": "Forgot"
  , "無工作經驗": "NoJob"
  , "update success": "Update Success"
  , "update fail": "Update Fail"
  , "如果你要繼續執行，請勾選這個核取方塊。": "Please select one at lease"
  // , "password": "Password"
  // , "app.Languages": "Language"
  // , "app.Colors": "Color"
  // , "app.pleaseSelect": "Please Select..."
  // , "app.add": "Add"
  // , "app.addPlus": "Add+"
  // , "app.sendCheck": "Send Check"
  // , "app.delete": "Delete"
  // , "app.Edit": "Edit"
  // , "app.Undelete": "UnDelete"
  // , "app.Audit": "Audit"
  // , "app.UnAudit": "UnAudit"
  // , "app.Submit": "Submit"
  // , "app.isDelete": "Please confirm Delete or not"
  // , "app.UploadYourFile": "Please Upload file..."
  // , "app.administrator": "Administrator can't be modified"
  // , "app.haveData": "There are details can't be deleted"
  // , "app.Query": "Query"
  // , "app.CloseAll": "Close All"
  // , "app.CloseOthers": "Close Others"

  // // helperText for Validator
  // , "noRepeat": "Can't Repeat"
  // , "required": "Required"
  // , "minLength": "Min Length"
  // , "maxLength": "Max Length"
  // //EmployeeTable
  // , "EmployeeTable": "Employee Table"
  // , "empName": "Name"
  // , "empAddress": "Address"
  // , "pensionRate": "Pension Rate"
  // , "seniorityY": "seniority(Y)"
  // , "seniorityM": "seniority(M)"
  // , "seniorityMTotal": "seniority(M) Total"
  // , "empPhone": "Phone"
  // , "companyId": "Company"
  // , "companyName": "Company"
  // , "empSID": "SID"
  // , "empAccount": "Account"
  // , "email": "email"
  // , "gender": "Gender"
  // , "genderText": "Gender"
  // , "dateBirth": "Birthday"
  // , "dateQuit": "Quit date"
  // , "dateHire": "Hire date"
  // , "dateCreate": "Create date"
  // , "ExemptClock": "Need Clock Card"
  // , "ExemptClockText": "Need Clock Card"
  // //CompanyTable
  // , "CompanyTable": "Company Table"
  // , "companyName": "Company Name"
  // , "taxNumber": "Tax Number"
  // , "address": "Address"
  // , "prefixTitle": "Prefix"
  // , "ZipCode": "Zip Code"
  // ////ShiftsTable
  // , "ShiftsTable": "Shifts Table"
  // , "sqShift": "Shifts Name"
  // , "shiftsName": "shifts Name"
  // , "WorkTimeStart": "WorkTime Start"
  // , "WorkTimeEnd": "WorkTime End"
  // , "RestTimeStart": "RestTime Start"
  // , "RestTimeEnd": "RestTime End"
  // , "workhours": "workhours"
  // //WageTypeTable
  // , "WageTypeTable": "Wage Type Table"
  // , "name": "Name"
  // , "kind": "Kind"
  // , "DateAdd": "Date Add"
  // , "currencyId": "Currency"
  // , "amount": "Amount"
  // , "wageStructure": "Wage Structure"
  // , "wageHistory": "Wage History"

  // //empInsurance
  // , "subSq": "No."
  // , "salaryRank": "Salary"
  // , "labourInsurance": "labourInsurance(P.)"
  // , "labourInsuranceEntity": "lobour Insurnce(Com.)"
  // , "healthCare": "health Care(P.)"
  // , "healthCareEntity": "health Care(Com.)"
  // , "year": "Year"
  // , "DateFrom": "Date From"
  // , "DateTo": "Date To"
  // , "local": "local"
  // //LeaveTypeContainer
  // , "LeaveTypeContainer": "LeaveTypeContainer"
  // , "sqLeaveType": "SQ"
  // , "LeaveTypeName": "Leave Type"
  // , "empId_applicant": "Applicant ID"
  // , "LeaveApplicantName": "Applicant"
  // , "empId_substitute": "Substitute ID"
  // , "LeaveSubstituteName": "Substitute"
  // , "dateFrom": "start date"
  // , "dateTo": "end date"
  // , "hours": "Hours"
  // , "checkType": "Check Type ID"
  // , "CheckTypeName": "Check Type"
  // , "leaveDescription": "Description"

  // //roles
  // , "RolesSetting": "Roles Setting"
  // , "rolesName": "Role Name"
  // //Attendance
  // , "AttendanceUploadTitle": "Attendance Upload"
  // , "isUpload": "Upload or not"
  // , "AttendanceRecordTitle": "Attendance Record"
  // , "everyday": "Date"
  // , "AttendanceStatus": "Attendance Status"
  // , "isWorkday": "Workday"
  // , "clockDate": "clockDate"
  // , "startTime": "Check-in time"
  // , "endTime": "Check-out time"
  // , "manualStartTime": "Manual Check-in"
  // , "manualEndTime": "Manual Check-out"
  // //AttendanceAdjust
  // , "AttendanceAdjustEmpTitle": "出勤人員"
  // , "PersonalAttendanceAdjustTitle": "出勤時數"
  // , "WorkOwedHours": "積欠小時"
  // , "WorkOverTime": "加班小時"
  // , "manualWorkOwedHours": "修正請假時數"
  // , "manualWorkOverTime": "修正加班時數"
  // , "AdjustConfirm": "調整確認"
  // , "AdjustDelete": "刪除調整"
  // , "AdjustTextNotConfirm": "未確認調整"
  // , "AdjustTextConfirmed": "確認調整時間:"
  // //WageCalculatorTable
  // , "WageCalculatorTitle": "薪資計算表"
  // , "BasicAmt": "薪資"
  // , "workOverTime133": "加班時數(一皆)"
  // , "workOverTime166": "加班時數(二皆)"
  // , "overtimeExpenses": "加班費"
  // , "workOwedTime": "請假/遲到時數"
  // , "owedExpenses": "請假/遲到扣薪"
  // , "totalSalary": "總薪資"
  // , "levelRank": "投保級距"
  // , "selfSaving": "員工自提"
  // , "pensionEntity": "退休金"
  // , "actualSalary": "實付薪資"
  // , "actualSalaryWithBonus": "實付薪資(含獎金)"
  // , "manualBonus01": "獎金(一)"
  // , "manualBonus02": "獎金(二)"
  // , "manualBonus03": "獎金(三)"
  // , "setAllmanualBonus01": "設定全獎金(一)"
  // , "setAllmanualBonus02": "設定全獎金(二)"
  // , "setAllmanualBonus03": "設定全獎金(三)"
  // //JobsType
  // , "sqJobsType": "NO."
  // , "JobsTypeName": "JobsType Name"
  // //CalendarTable
  // , "holidayDescription": "Description"
  // , "multiplierRate": "Rate"
  // , "DateRest": "Date"

};
export default en;